import { render, staticRenderFns } from "./BankStatementManualUploadItem.vue?vue&type=template&id=589d40a0&scoped=true&"
import script from "./BankStatementManualUploadItem.vue?vue&type=script&lang=js&"
export * from "./BankStatementManualUploadItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=589d40a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d40a0",
  null
  
)

export default component.exports